import { Transactions } from "modules/financial";

const TransactionsPage = () => {
  return <Transactions />;
};

export default TransactionsPage;
